import styled from '@emotion/styled'
import React, { memo } from 'react'

import { Item, Props as ItemProps } from './Item'

export interface Props {
  items: ItemProps[]
}

export const ExperiencesList = memo(function ExperiencesList({ items }: Props) {
  if (!items) {
    return null
  }

  if (items.length < 1) {
    return null
  }

  return (
    <Container>
      {items.map((item, index) => (
        <Item key={index} {...item} />
      ))}
    </Container>
  )
})

const Container = styled.section`
  display: grid;
  gap: 6rem 7.778vw;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 7.5rem;
  padding: 0 5vw 11.25rem;

  @media (max-width: 1199px) {
    display: block;
    margin-top: 3rem;
    padding: 0 2rem 3.75rem;
  }
`
